import { createFileRoute } from '@tanstack/react-router';

// B-new-19 slice 3 — resume + application-answers settings page.
// Component body lives in settings.resume.lazy.tsx (code-splits via
// createLazyFileRoute per Phase Bundle-Splitting-1).
export const Route = createFileRoute('/$locale/settings/resume')({
  ssr: false,
});
